import { render } from "./PartList.vue?vue&type=template&id=c0aa78e0"
import script from "./PartList.vue?vue&type=script&lang=js"
export * from "./PartList.vue?vue&type=script&lang=js"
script.render = render

export default script